import { customerConversationsAnalyticsAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-analytics/src/customerConversationsAnalyticsAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

export const customerConversationsAnalyticsRoutePageEntryPoint: ReturnType<
	typeof createPageEntryPoint
> = createPageEntryPoint({ main });
